import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../CommonComponents/OPL/Input/InputNumberMask';

interface Props<T extends FieldValues> {
  index: number;
  control: Control<T>;
  errorMessage?: string;
}

export function OwnershipPercentage<T extends FieldValues>({
  index,
  control,
  errorMessage,
}: Props<T>) {
  return (
    <Controller
      control={control}
      name={`ownerModel.${index}.Percentage` as Path<T>}
      render={({ field: { value, onChange } }) => (
        <InputNumberMask
          value={value}
          onChange={onChange}
          css={{ flex: 1 }}
          label="Ownership %"
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          maxLength={5}
          formVariant={errorMessage ? 'error' : undefined}
          helperText={errorMessage}
        />
      )}
    />
  );
}
